import { Component, OnInit } from "@angular/core";
import { filter, first } from "rxjs";
import { LogClass, Logger, LogMethod } from "src/app/logger";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { SubSink } from "subsink";
import { Circulation } from "../../../interfaces";
import { NavigationService } from "../../../services/navigation.service";

@LogClass()
@Component({
    selector: "circ-form-new",
    templateUrl: "./new.component.html",
    styleUrls: ["./new.component.scss"],
    standalone: false
})
export class CirculationFormNewComponent implements OnInit {
  public loading = true;
  private subs = new SubSink();
  public circulation: Circulation;

  private logger: Logger;

  constructor(
    private circulationFacade: CirculationFacade,
    private navigate: NavigationService,
    private notificationFacade: NotificationFacade
  ) {}

  @LogMethod()
  public onAbort(): void {
    this.navigate.back();
  }

  @LogMethod()
  public onError(error: string): void {
    this.navigate.toError(error);
  }

  @LogMethod()
  public ngOnInit(): void {
    this.circulationFacade
      .getNewCirculation()

      .subscribe(
        (c) => this.setCirculation(c),
        (err) =>
          this.navigate.toError(
            "Error in Circulation load. - " + JSON.stringify(err)
          )
      );
  }

  @LogMethod()
  private setCirculation(circulation: Circulation) {
    this.circulation = circulation;
    this.loading = false;
  }

  private loadCirculation() {
    this.circulationFacade
      .savedCirculationId()
      .pipe(
        filter((x) => !!x),
        first()
      )
      .subscribe({
        next: (id) => this.navigate.toCirculation(id),
        error: (err) =>
          this.navigate.toError(
            "Error in Circulation save. - " + JSON.stringify(err)
          )
      });
  }

  @LogMethod()
  public onSave(value: {
    circulation: Circulation;
    navigateToOverview: boolean;
  }): void {
    this.loading = true;
    this.subs.sink = this.circulationFacade.save(value.circulation).subscribe({
      next: () => {
        if (value.navigateToOverview) {
          this.notificationFacade.success("owner.changed.save.success");
          this.navigate.toCirculationOverview();
        } else {
          this.loadCirculation();
        }
      },
      error: () => {
        if (value.navigateToOverview) {
          this.notificationFacade.showError("owner.changed.save.fail");
        }
      }
    });
  }
}
